import { emptyString } from "../../../constants";

//Dynamic spinner for page re-rendering
export function Spinner(props) {
  //This check in the props has been added for any screen that needs to be completely covered by spinner
  const { completeSpinner = false } = props;
  return (
    <div
      className={`spinner modal-backdrop fade in show ${
        completeSpinner ? "complete-backdrop" : emptyString
      }`}
      data-testid="spinner"
    >
      <div className="report-spinner">
        <div className="loader">
          <div className="face">
            <div className="circle"></div>
          </div>
          <div className="face">
            <div className="circle"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
